<script setup lang="ts">
import { useTerminologyData, type TerminologyEntry } from '@/composables/useTerminologyData';
import { useI18n } from 'vue-i18n';
import { computed, nextTick, onMounted, ref, type Ref } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';
import KpDropdown from '@kp/geofy-vuejs-lib/tg-system/components/KpDropdown.vue';

const terminology = [
    { index: 0, title: useI18n().t('faq_about_title'), data: useTerminologyData(['faq', 'about']) },
    { index: 5, title: useI18n().t('faq_account_title'), data: useTerminologyData(['faq', 'account']) },
    { index: 1, title: useI18n().t('faq_planungsgeschaefte_title'), data: useTerminologyData(['faq', 'planungsgeschaefte']) },
    { index: 2, title: useI18n().t('faq_daten_title'), data: useTerminologyData(['faq', 'daten']) },
    { index: 3, title: useI18n().t('faq_unterstuetzung_title'), data: useTerminologyData(['faq', 'unterstuetzung']) },
    { index: 4, title: useI18n().t('faq_benachrichtigung_title'), data: useTerminologyData(['faq', 'benachrichtigung']) },
    //{ index: 3, title: useI18n().t('faq_services_title'), data: useTerminologyData(['faq', 'services']) }
];
const actPage: Ref<number> = ref(0);

const actData = computed((): Ref<TerminologyEntry[]> => {
    for (let i = 0; i < terminology.length; i++) {
        if (terminology[i].index === actPage.value) {
            return terminology[i].data.data;
        }
    }
    return ref([]);
});

function navSelected(index: number) {
    actPage.value = index;
}

const largeAccordion = computed(() => windowWidth.value > 1056);

const windowWidth = ref(window.innerWidth);
onMounted(() => {
    nextTick(() => {
        window.addEventListener('resize', onResize);
    });
});

onBeforeRouteLeave(() => {
    window.removeEventListener('resize', onResize);
});

function onResize() {
    windowWidth.value = window.innerWidth;
}
</script>

<template>
    <section class="my-2_5rem ktg-main-container">
        <h2 class="ktg-title-02 mb-2rem">{{ $t('fragen_amp_antworten') }}</h2>
        <p class="ktg-body-lead" v-html="$t('faq_info_text')"></p>
    </section>
    <section class="faq ktg-main-container">
        <ktg-vertical-navigation v-if="largeAccordion" class="faq-nav" content-title="Thema auswählen">
            <ktg-vertical-navigation-item
                v-for="data in terminology"
                :key="data.title"
                :selected="data.index === actPage"
                @click="navSelected(data.index)"
                icon="dropdown-arrow-right-small"
            >
                {{ data.title }}
            </ktg-vertical-navigation-item>
        </ktg-vertical-navigation>
        <ktg-field v-if="!largeAccordion">
            <ktg-label for="thema_chooser">{{ $t('choose_thema') }}</ktg-label>
            <KpDropdown
                appearance="grey"
                class="faq-nav w-full"
                v-model="actPage"
                :options="terminology"
                display-field="title"
                value-field="index"
                name="thema_chooser"
                :placeholder="$t('please_chose')"
            ></KpDropdown>
        </ktg-field>
        <div class="content">
            <ktg-accordion class="accordion">
                <ktg-accordion-item
                    v-for="data in actData?.value || []"
                    :key="data.title"
                    :content-title="data.title"
                    :size="largeAccordion ? 'large' : 'small'"
                >
                    <span class="ktg-body" v-html="data.content"></span>
                </ktg-accordion-item>
            </ktg-accordion>
        </div>
    </section>
</template>

<style scoped>
.faq {
    gap: 1rem;
    display: grid;
    margin-bottom: 5rem;
    grid-template-areas:
        'menu'
        'content';

    .faq-nav {
        grid-area: menu;
    }
    .content {
        grid-area: content;
    }
}

@media only screen and (min-width: 1056px) {
    .faq {
        gap: 2.5rem;
        grid-template-columns: 1fr 3fr 1fr;
        grid-template-areas: 'menu content .';
    }
}
</style>
